// eslint-disable-next-line import/prefer-default-export
export const areaEnum = {
  PREPARATION: 'preparation',
  RECEIVE_DELIVERY: 'receive_delivery',
}
